import { BASE } from "../config";

/**
 * Helper function to get the correct video URL for display
 * Handles both old string format and new object format
 * @param {string|object} video - Video data (string URL or object with url property)
 * @param {string} baseUrl - Base URL to prepend if needed (default: BASE)
 * @returns {string} - The complete video URL
 */
export const getVideoUrl = (video, baseUrl = BASE) => {

  if (!video) {
    return "";
  }

  // If video is a string (old format)
  if (typeof video === "string") {
    const result = video.includes("http") ? video : `${baseUrl}${video}`;
    return result;
  }

  // If video is an object with url property (new format)
  if (video && typeof video === "object" && video.url) {
    const result = video.url.includes("http") ? video.url : `${baseUrl}${video.url}`;
    return result;
  }

  // Fallback
  return "";
};

/**
 * Helper function to check if a video URL is external (starts with http)
 * @param {string|object} video - Video data
 * @returns {boolean} - True if external URL
 */
export const isExternalVideoUrl = (video) => {
  if (!video) return false;

  if (typeof video === "string") {
    return video.includes("http");
  }

  if (video && typeof video === "object" && video.url) {
    return video.url.includes("http");
  }

  return false;
};
